<template>
  <ElDialog
    class="agent-permissions-modal"
    destroy-on-close
    width="52rem"
    :title="$t('AGENTS.EDIT_PERMISSION.TITLE')"
    :visible="value"
    @close="close"
  >
    <div
      v-loading="appsLoading"
      class="row align-stretch agent-permissions-modal__wrapper"
    >
      <div class="columns small-12 medium-4 agent-permissions-modal__menu">
        <AgentPermissionsGroup
          v-model="selectedGeneralPermissionGroup"
          :items="generalPermissionsGroups"
          class="agent-permissions-modal__menu-general"
          @input="changeGeneralPermissions"
        />
        <AgentPermissionsApps
          v-model="selectedApp"
          class="agent-permissions-modal__menu-apps"
          @input="changeAppPermissions"
        />
      </div>
      <div class="columns agent-permissions-modal__permission-list">
        <AgentGeneralPermissions
          v-if="selectedGeneralPermissionGroup"
          :permissions="permissions"
          :selected-general-permission-group="selectedGeneralPermissionGroup"
          @input="emitNewPermissions"
        />
        <AgentAppPermissions
          v-else-if="selectedApp"
          :permissions="permissions"
          :selected-app="selectedApp"
          @input="emitNewPermissions"
        />
      </div>
    </div>
    <div slot="footer" class="agent-permissions-modal__footer">
      <ElButton
        class="agent-permissions-modal__cancel-btn"
        type="text"
        @click="close"
      >
        {{ $t('CANCEL') }}
      </ElButton>
      <ElButton
        :disabled="appsLoading"
        :loading="isProcessing"
        type="primary"
        @click="save"
      >
        {{ $t('AGENTS.APPLY_PERMISSIONS_BTN') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
import AgentPermissionsGroup from './AgentPermissionsGroup';
import AgentPermissionsApps from './AgentPermissionsApps';
import AgentGeneralPermissions from './AgentGeneralPermissions';
import AgentAppPermissions from './AgentAppPermissions';

export default {
  name: 'AgentPermissionsModal',
  components: {
    AgentPermissionsGroup,
    AgentPermissionsApps,
    AgentGeneralPermissions,
    AgentAppPermissions,
  },
  props: {
    appsLoading: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    permissions: {
      type: Object,
      default: null,
    },
    isProcessing: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedApp: '',
      selectedGeneralPermissionGroup: 'general',
    };
  },
  computed: {
    generalPermissionsGroups() {
      return Object.keys(this.permissions.general_permissions);
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    emitNewPermissions(val) {
      this.$emit('update:permissions', val);
    },
    save() {
      this.$emit('submit');
    },
    changeGeneralPermissions() {
      this.selectedApp = '';
    },
    changeAppPermissions() {
      this.selectedGeneralPermissionGroup = '';
    },
  },
};
</script>

<style lang="scss">
.agent-permissions-modal {
  &__wrapper {
    height: 25rem;
  }

  &__menu {
    display: flex;
    flex-direction: column;

    @include breakpoint(small only) {
      border-left: 0;
    }

    margin-right: $global-margin;
    padding-right: $global-padding * 0.1875 !important;
    border-right: 1px solid $lb-light-gray;
    @include rtl() {
      margin-right: 0;
      margin-left: $global-margin;
      border-left: 1px solid $lb-light-gray;
      border-right: 0;
      padding-right: 0 !important;
      padding-left: $global-padding * 0.1875 !important;
    }

    &-apps {
      margin-top: $global-margin * 1.25;
      flex: 1 0 0;
    }
  }

  .el-dialog {
    position: relative;

    &__body {
      padding: $--dialog-padding-primary;
    }

    &__footer {
      position: absolute;
      bottom: 0;
      right: 0;
      @include rtl() {
        left: 0;
        right: auto;
      }
    }
  }

  &__permission-list {
    padding-bottom: $--dialog-padding-primary * 2.5;
  }

  &__cancel-btn {
    color: #919191;
    font-weight: bold;
    font-size: rem-calc(14px);
  }
}
</style>
